"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TauntedEffectHandler = exports.TauntedEffectArgs = void 0;
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const core_1 = require("../../vfx/core");
const LocationSelector_1 = require("../../vfx/LocationSelector");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const core_2 = require("../../event-handlers/core");
class TauntedEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Taunted;
        this.__typeName = "Taunted";
        this.name = "Taunted";
        this.harmful = true;
    }
}
exports.TauntedEffectArgs = TauntedEffectArgs;
let TauntedEffectHandler = class TauntedEffectHandler {
    apply(sequence, container, state) {
        if (container.hasEffectOfType(state.targetId, EffectType_1.EffectType.TauntImmunity)) {
            container.cancelEffect(sequence, state.id);
            return;
        }
        sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(state.targetId, "feet", "front"), "FallingBloodMissle", false));
        state.meta.ehId = container.registerEventHandler(state.creatorId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new core_2.CancelEffectsEventHandlerArgs([
            state.id
        ]));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.ehId);
    }
};
TauntedEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Taunted)
], TauntedEffectHandler);
exports.TauntedEffectHandler = TauntedEffectHandler;
